<script setup lang="ts">
import { useI18n } from 'vue-i18n'
export interface MiestoRealizacieProps {}

const props = defineProps<MiestoRealizacieProps>()
const { t } = useI18n()
</script>

<template>
  <CanSkipWarningText v-if="$attrs.canSkip" />
  <IDSKHeading as="h1" variant="xl">{{ t('zoppm.step7.mainHeading') }}</IDSKHeading>
  <IDSKParagraph v-if="!$attrs.canSkip" variant="large" class="mb-9">{{
    t('zoppm.step7.fyzickaOsoba.mainInfo')
  }}</IDSKParagraph>
</template>

<style lang="scss"></style>
